export default __webpack_public_path__ + "static/media/amenity-5.24226cc0.jpg";